export default __webpack_public_path__ + "static/media/sticker.d61a6dfa.jpeg";